import { render, staticRenderFns } from "./ReservaCartaoMenu.vue?vue&type=template&id=254fcaf1&scoped=true&"
import script from "./ReservaCartaoMenu.vue?vue&type=script&lang=js&"
export * from "./ReservaCartaoMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartaoMenu.vue?vue&type=style&index=0&id=254fcaf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254fcaf1",
  null
  
)

export default component.exports